export default (params) => ({
  trigger: {
    name: 'options_row.change_quantity',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
      type: {
        enum: [
          'add',
          'remove',
        ],
      },
      quantity: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'product_type_section',
          'product_type_section_alternative_overlay',
          'options_row',
        ],
      },
    },
    event: {
      name: 'change_quantity',
    },
  },
});
